import { IGalleryItem } from "../../types/types";

export const GalleryContents: IGalleryItem[] = [
  {
    titleEn: "FPL Summer 2026 Finals",
    titleFi: "FPL Kesä 2026 Finaalit",
    dateFi: "12-13.09.2026",
    dateEn: "12-13 September 2026",
    place: "Paidia / Nokia Arena Tampere",
    link: "https://www.flickr.com/photos/203676740@N08/albums/72177720335657655",
    image: ["fplkesa26.jpg", "fplkesa26-2.jpg", "fplkesa26-3.jpg"],
  },
  {
    titleEn: "NEVER LATE TO GAME 2",
    titleFi: "NEVER LATE TO GAME 2",
    dateFi: "19.-20.12.2025",
    dateEn: "19-20 December 2025",
    place: "Cafe & Bar Lategame, Tampere",
    link: "https://www.flickr.com/photos/203676740@N08/albums/72177720331041412",
    image: ["lategame25.jpg", "lategame25-2.jpg", "lategame25-3.jpg"],
  },
  {
    titleEn: "FPL Summer 2025 Finals",
    titleFi: "FPL Kesä 2025 Finaalit",
    dateFi: "20.-21.9.2025",
    dateEn: "20-21 September 2025",
    place: "Paidia / Nokia Arena, Tampere",
    link: "https://www.flickr.com/photos/203676740@N08/albums/72177720329389327/",
    image: ["fpl25kesa.jpg", "fpl25kesa-2.jpg", "fpl25kesa-3.jpg"],
  },
  {
    titleEn: "FPL Summer 2024 Finals",
    titleFi: "FPL Kesä 2024 Finaalit",
    dateFi: "26.-27.10.2024",
    dateEn: "26-27 October 2024",
    place: "Paidia / Nokia Arena, Tampere",
    link: "https://www.flickr.com/photos/203676740@N08/albums/72177720329415744/",
    image: ["fpl24kesa.jpg", "fpl24kesa-2.jpg", "fpl24kesa-3.jpg"],
  },
  {
    titleEn: "NEVER LATE TO GAME",
    titleFi: "NEVER LATE TO GAME",
    dateFi: "27.-28.1.2024",
    dateEn: "27-28 January 2024",
    place: "Cafe & Bar Lategame, Tampere",
    link: "https://www.flickr.com/photos/203676740@N08/albums/72177720329387381",
    image: ["lategame24.jpg", "lategame24-2.jpg", "lategame24-3.jpg"],
  },
];
